module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen-glx-negro-cosmos.f900835b.png";